// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.actCard[data-v-3980dd78]{\n padding: 0px;\n}\n", ""]);
// Exports
module.exports = exports;
